<template>
    <div @click="goToPage" v-if="summary" class="summary_box relative h-0 cursor-pointer overflow-hidden" :class="[summary ? summary.slug : '']">
            <p class="title_summary_2 absolute top-0 left-0 w-full h-full flex justify-start items-center text-xl md:text-xs lg:text-2xl text-white pl-4 md:ml-0 lg:pl-4" v-html="summary.title_summary_2"></p>
    </div>

</template>

<script>
    export default {
        name: 'SummaryBoxText',
        props: {
            summary: null
        },
        methods: {
            goToPage() {
                this.$router.push({ name: 'catalogue', params: { slug: this.summary.slug } });
            }
        }
    };
</script>

<style scoped lang="scss">
    .summary_box {
        width: calc($box_size_mobile - $box_spacing);
        padding-bottom: calc($box_size_mobile - $box_spacing);
        margin-top: $box_spacing;
        @media (min-width: 768px) {
            width: calc($box_size - $custom_varible);
            padding-bottom: calc($box_size - $custom_varible);
            margin-left: $box_spacing;
        }
        .summary_box_overlay {
            background-color: #CEDFF5;
            color: #001A70;
            font-family: Frutiger LT;
            transition: opacity 250ms ease-in-out;
            @media (min-width:1024px) {
                &:hover {
                    opacity: 1;
                }
           }
        }
        
    }
    .title_summary_2{
            opacity: 1;
            font-family: Frutiger LT;
            background-color: #CEDFF5;
            color: #001A70;
            transition: opacity 250ms ease-in-out;
            @media (min-width:1024px) {
                font-size: 27px;
                &:hover {
                    opacity: 1;
                }
           }
            
        }
</style>
